<template>
  <div class="p-4">
    <br>
    <h3>API Documentation</h3>
    <hr><br><br>
    <p>
      This is the documentation to use this API of Anywords. You can use to get words from here.
    </p>
    <h5><b>Get 5 post</b></h5>
    <div style="background-color:#0A0A0A0A; padding:10px;">
      <code>
        https://young-brook-59453.herokuapp.com/api/v1/get-messages-from/'number'
      </code>
    </div>
    <p>
      You will get 5 post start from anynumber you want. Change 'number' to any number you want. it will return you a JSON.
    </p>
    <h5><b>Get a random</b></h5>
    <div style="background-color:#0A0A0A0A; padding:10px;">
      <code>
        https://young-brook-59453.herokuapp.com/api/v1/random-words
      </code>
    </div>
    <p>
      You will get a random post in JSON object from our server.
    </p>
    <h5><b>Get a post</b></h5>
    <div style="background-color:#0A0A0A0A; padding:10px;">
      <code>
        https://young-brook-59453.herokuapp.com/api/v1/at-words/'number'
      </code><br>
      <code>
        https://young-brook-59453.herokuapp.com/api/v1/last-words
      </code><br>
      <code>
        https://young-brook-59453.herokuapp.com/api/v1/latest-words
      </code>
    </div>
    <p>
      You will get a post in JSON object from our server. Change 'number' to any number you want.
      You may get the last and the latest post just use the second and the third url.
    </p>
  </div>
</template>

<style scoped>
hr {
      border: 0;
      height: 1px;
      width:30%;
      float:left;
      background-image: linear-gradient(to right, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0));
  }
</style>

<script>

export default {

};
</script>
